import React, { memo, useEffect } from "react";
import Map, { Marker, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import useLocation from "../../../hooks/useLocation";
import UserLocationMarker from "../../UserLocationMarker/UserLocationMarker";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  setCoordinates,
  setDataRoute,
  setLandMarks,
} from "../../../redux/slice/routeSlice";
import { navigation } from "../../../services/rest/mapbox/navigationMap";
import LineOfRoute from "./LineOfRoute";
import { handleNearestPoint } from "./handleActionsMaps";
import RunCircleIcon from "@mui/icons-material/RunCircle";

const MapComponent = memo(({ setLoading }) => {
  const { location, viewport, setViewport } = useLocation();
  const { route } = useSelector((state) => state.routeReducer);
  const dispatch = useDispatch();
  const mapRef = React.useRef();

  // Efecto para centrar el mapa cuando hay coordenadas de ruta
  useEffect(() => {
    if (route?.coordinates && route.coordinates.length > 0) {
      // Tomamos la primera coordenada de la ruta
      const firstCoordinate = route.coordinates[0];
      setViewport({
        ...viewport,
        longitude: firstCoordinate[0],
        latitude: firstCoordinate[1],
        zoom: 17,
      });
    }
  }, [route?.coordinates]); // Se ejecuta cuando cambian las coordenadas

  const handleMapPress = async (evt) => {
    try {
      const { lngLat } = evt;
      if (route?.landMarks.length + 1 <= 25) {
        const updateCoordinates = [
          ...route?.landMarks,
          [lngLat?.lng, lngLat?.lat],
        ];
        dispatch(setLandMarks({ landMarks: updateCoordinates }));

        //LLamamos a la API de navigation si tiene mas de un punto
        if (route.landMarks.length >= 1) {
          setLoading(true);
          const coordinatesString = updateCoordinates
            .map((coord) => coord.join(","))
            .join(";");

          const newCoor = await navigation(coordinatesString);

          dispatch(
            setDataRoute({
              distance: newCoor?.distance ?? 0,
              estimatedTime: newCoor?.duration ?? "0 min",
            })
          );
          dispatch(
            setCoordinates({
              coordinates: newCoor?.geometry?.coordinates ?? [],
            })
          );
          //Verificamos cual de las nuevas coordenadas es la mas cercana al punto seleccionado en el mapa
          const updateLandMarks = handleNearestPoint(
            [lngLat?.lng, lngLat?.lat],
            newCoor?.geometry?.coordinates,
            updateCoordinates
          );

          dispatch(
            setLandMarks({
              landMarks: updateLandMarks ?? [],
            })
          );
          setLoading(false);
        } else {
          dispatch(
            setCoordinates({
              coordinates: updateCoordinates,
            })
          );
        }
      } else {
        toast.error("Verifique su ruta. \n No puede tener más de 25 puntos.");
        return;
      }
    } catch (error) {
      setLoading(false);
      console.log("Error al dibujar ruta ", error);

      toast.error(
        "En este momento no puede dibujar su ruta.\n Intentelo más tarde."
      );
    }
  };

  return (
    <Map
      {...viewport}
      ref={mapRef}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      onMove={(evt) => setViewport(evt.viewState)}
      mapStyle="mapbox://styles/mapbox/streets-v11"
      onClick={(evt) => handleMapPress(evt)}
    >
      {/* Controles de navegación */}
      <NavigationControl position="top-right" />
      {route?.coordinates && route?.coordinates.length >= 2 && <LineOfRoute />}
      {route?.landMarks &&
        route?.landMarks.map((landMark, key) => (
          <Marker latitude={landMark[1]} longitude={landMark[0]} key={key}>
            <RunCircleIcon style={{ color: "red" }} />
          </Marker>
        ))}
      {/* Ejemplo de un marcador */}
      <Marker latitude={location.latitude} longitude={location.longitude}>
        <UserLocationMarker type={"location"} />
      </Marker>
    </Map>
  );
});

export default MapComponent;
